import z from "zod";

export const LanguageSchema = z.union([
  z.literal("en"),
  z.literal("fr"),
  z.literal("pt"),
  z.literal("es"),
  z.literal("ja"),
  z.literal("zh"),
  z.literal("ru"),
  z.literal("tr"),
  z.literal("de"),
  z.literal("sv"),
  z.literal("sk"),
  z.literal("nl"),
  z.literal("it"),
  z.literal("fi"),
  z.literal("ro"),
  z.literal("cs"),
  z.literal("pl"),
  z.literal("ko"),
  z.literal("vi"),
  z.literal("he"),
  z.literal("ar"),
]);

export type ILanguage = z.infer<typeof LanguageSchema>;

export const MultilingualLanguagesSchema = z
  .object({
    name: z.string().min(1),
    code: z.string().min(2),
    nativeName: z.string().min(1),
  })
  .array();

export type IMultilingualLanguage = z.infer<typeof MultilingualLanguagesSchema>;
